import { JM_ENVIRONMENT } from "app/Firebase";
import { ActAsRequestError, registerActAsCacheClearer } from "./actAsSession";
import { QueryCache, QueryClient } from "@tanstack/react-query";

export const queryClient = new QueryClient({
  queryCache: new QueryCache({
    onError: () => {
      // Intentionally suppressed here; app-level handlers decide how to surface failures.
    },
  }),
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      refetchOnReconnect: false,
      retry: (failureCount, error) => !(error instanceof ActAsRequestError) && JM_ENVIRONMENT !== "DEVELOPMENT" && failureCount < 3,
    },
  },
});

registerActAsCacheClearer(() => {
  // Mounted panels need their observers retained while data reloads for the new user.
  void queryClient.resetQueries();
  queryClient.getMutationCache().clear();
});
